class ShopifyWishlist {

    localStorageKey = 'shopify-wishist';

    initButtonEvents () {
        this.buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                const productHandle = button.getAttribute('data-product-handle');
                if (!productHandle) return;

                this.toggleProduct(productHandle);
            })
        })
    }

    fetchProductCard (productHandle) {

        return fetch(window.Shopify?.routes.root + `products/${productHandle}.js`)
            .then(response => response.json())
            .then(product => {
                const price = new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: 'EUR'
                }).format(product.price / 100);
                const html = `
                    <div class="card-container">
                        <button data-wishlist data-product-handle="${product.handle}" class="wishlist-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                            </svg>
                        </button>
                        <a class="card card-js" href="${product.url}">
                            <div class="card__picture-wrapper">
                                <product-card-image class="card__picture" show-second-media="true">
                                <div class="card__product-image ratio-portrait card__product-image--hover-effect card__product-image--show-second have-second-img" oncontextmenu="return false">
                                    <img draggable="false" src="${product.images[0]}" alt="${product.title}" class="card__image">
                                </div>
                                </product-card-image>
                            </div>
                            <div class="card__content card__content--center">
                                <div class="card__info">
                                    <div class="card__product-info">
                                        <p class="card__vendor card__vendor--minimal_heavy">${product.vendor}</p>
                                        <div class="card__title card__title--minimal_heavy" data-name-characters="100">
                                            <p class="card__title-text card__title-js">${product.title}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card__price card__price--minimal_heavy">
                                    <div class="price price--minimal_heavy ">
                                        <div class="price__wrapper">
                                            <div class="price__regular">
                                                <span class="visually-hidden">Regulärer Preis</span>
                                                <span class="regular-price">${price}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>`;
                return html;
            })
            .catch((error) => console.error(`Failed to load product card (handle: ${productHandle})`, error))
    };

    async initGrid () {
        const grids = document.querySelectorAll('[data-wishlist-grid]');
        if (grids.length === 0 || this.wishList.length === 0) return;

        const requests = this.wishList.map(this.fetchProductCard);
        const responses = await Promise.all(requests);
        const wishlistCards = responses.join('');

        grids.forEach((grid) => {
            grid.innerHTML = wishlistCards;
        });

        this.buttons = document.querySelectorAll('[data-wishlist]');
        this.initButtonEvents();
        this.refreshButtons();
    }

    refreshButtons () {
        this.buttons.forEach((button) => {
            const productHandle = button.getAttribute('data-product-handle');
            if (!productHandle) return;

            if (this.wishList.includes(productHandle)) {
                button.classList.add('is-active');
            } else {
                button.classList.remove('is-active');
            }
        })
    }

    toggleProduct (productHandle) {
        this.wishList =
            this.wishList.includes(productHandle)
                ? this.wishList.filter(v => v !== productHandle)
                : [...this.wishList, productHandle];
        this.updateLocalStorage();
    }

    updateLocalStorage () {
        localStorage.setItem(this.localStorageKey, this.wishList.toString());
        this.refreshButtons();
    }

    constructor () {
        this.wishList = localStorage.getItem(this.localStorageKey) ? localStorage.getItem(this.localStorageKey).split(',') : [];
        this.buttons = document.querySelectorAll('[data-wishlist]');
        this.initButtonEvents();
        this.refreshButtons();
        this.initGrid();
    }

}

window.addEventListener('DOMContentLoaded', () => {
    new ShopifyWishlist();
})